var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ViewWrapper',[_c('h1',[_vm._v("\n    CashFlo App\n  ")]),_c('p',[_vm._v("\n    Page not found.\n  ")]),_c('ButtonLink',{attrs:{"url":"cashflo://email_verified"}},[_vm._v("\n    Open Cashflo\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }